import React from 'react';
import PropTypes from 'prop-types';

import ButtonDeprecated from "core/gd-components/buttons/gd-button/gd-button";
import TemplatesListModule from "./managers/templates-list-module";
import ViewTemplates from "src/core/manager/view-templates/view-templates";
import ViewsTemplatesCollection from "src/core/model2/view-preset/view-templates-collection";
import GenericList from "core/gd-modules/generic-list/render/list";
import VScroll from "src/core/gd-components/scrolling/custom-v-scroll/v-scroll";

export default class NewViewTemplateSaveTypeOverride extends React.Component {

    static propTypes = {
        viewSystemType: PropTypes.any,

        onSubmit: PropTypes.func.isRequired,
    }

    constructor(props) {
        super(props);

        // retrieve all available to override templates
        const isManager = gd.ac.check.company.isManager(gd.companyId);
        const viewTemplates = _.filter(new ViewTemplates().getViewTemplates(props.viewSystemType), template=>
            isManager || (template.access === 'private' && template.userId === gd.user.id)
        );

        const viewsTemplatesDataCollection = new ViewsTemplatesCollection();
        viewsTemplatesDataCollection.reset(viewTemplates);

        this.module = new TemplatesListModule(this);
        this.module.data.collection = viewsTemplatesDataCollection;
        this.module.data.process(); // should be called when all settings set (filters, sort, search, group by)
    }

    // is called from TemplatesListModule
    updateSubmitButton = () => {
        const selectedItemsIds = this.module.selection.getSelected();
        this.submitButton.setType(selectedItemsIds.length > 0 ? 'primary' : 'disabled');
    }

    onButtonClick = () => {
        const selectedItemsIds = this.module.selection.getSelected();
        const item = this.module.data.collection.get(selectedItemsIds[0]);

        this.props.onSubmit({
            templateId: item.templateId,
        });
    }

    render() {
        return (
            <React.Fragment>
                <VScroll className="templates-scroll">
                    <GenericList module={this.module}/>
                </VScroll>

                <div className="actions">
                    <ButtonDeprecated ref={r=>this.submitButton = r}
                                      type="disabled"
                                      label="Save"
                                      onClick={this.onButtonClick}/>
                </div>
            </React.Fragment>
        )
    }
}